import axios from 'axios'

const apiUrl = process.env.REACT_APP_API_URL
const apiKey = process.env.REACT_APP_API_KEY
/**
 * Fetch all users from the backend
 * Returns an array of user objects
 */

const headers_obj = {
  headers: {
    'ZCFKEY': apiKey
  }
}
export const getAllUsers = async () => {
  try {
    const res = await axios.get(`${apiUrl}getAllUsers`, headers_obj)
    return res.data.data || []
  } catch (error) {
    console.error('Error fetching users:', error)
    return []
  }
}

/**
 * Fetch all roles from the backend
 * Returns an array of role names
 */
export const getAllRoles = async () => {
  try {
    const res = await axios.get(`${apiUrl}getAllRoles`, headers_obj)
    if (res.data && res.data.data) {
      return res.data.data.map(role => ({
        RoleID: role.RoleID, // ID from API
        RoleName: role.Role // Name from API
      }))
    }
    return []
  } catch (error) {
    console.error('Error fetching roles:', error)
    return []
  }
}

export const getAllBranch = async (status = false) => {
  try {
    var query = (status === true) ? "?is_active=true" : "?is_active=";
    const res = await axios.get(`${apiUrl}getAllBranches${query}`, headers_obj)
    if (res.data && res.data.data) {
      return res.data.data.map(branch => ({
        Branch_Name: branch.name, // ID from API
        Branch_ID: branch.ROWID, // Name from API
        ...branch
      }))
    }
    return []
  } catch (error) {
    console.error('Error fetching branch:', error)
    return []
  }
}

export const getBranches = async (status = false) => {
  try {
    var query = (status === true) ? "?is_active=true" : "?is_active=";
    const res = await axios.get(`${apiUrl}getAllBranches${query}`, headers_obj)
    if (res.data && res.data.data) {
      return res.data.data
    }
    return []
  } catch (error) {
    console.error('Error fetching branch:', error)
    return []
  }
}

export const getTimeSlots = async () => {
  try {
    const res = await axios.get(`${apiUrl}getTimeSlots`, headers_obj)
    console.log(res, 'asdasdasd')
    if (res.data && res.data.time_slots) {
      return res.data.time_slots
    }
    return []
  } catch (error) {
    console.error('Error fetching branch:', error)
    return []
  }
}
export const getAvailableSlots = async (branch_id, package_id, date) => {
  try {
    const res = await axios.get(
      `${apiUrl}available-slots?branch_id=${branch_id}&package_id=${package_id}&booking_date=${date}`,
      headers_obj
    )
    console.log(res, 'asdasdasd')
    if (res && res?.data && res?.data?.data?.slots) {
      return res?.data?.data?.slots
    }
    return []
  } catch (error) {
    console.error('Error fetching branch:', error)
    return []
  }
}

export const getAddons = async (branch_id = '', is_active = '') => {
  try {
    var url = `${apiUrl}addons`
    console.log(branch_id, 'qweqweqwe')
    if (branch_id) {
      url = `${url}?branch_id=${branch_id}`
    }
    if (is_active) {
      url = `${url}&is_active=${is_active}`
    }
    const res = await axios.get(url, headers_obj)
    if (res.data && res.data.addons) {
      return res.data.addons
    }
    return []
  } catch (error) {
    console.error('Error fetching addons:', error)
    return []
  }
}

export const getUsersFromUsersTableById = async user_id => {
  try {
    const res = await axios.get(`${apiUrl}get/user/${user_id}`, headers_obj)
    console.log(res, 'gowty')
    if (res.data) {
      return res.data
    }
    return []
  } catch (error) {
    console.error('Error fetching branch:', error)
    return []
  }
}
export const getalluser_ = async () => {
  try {
    console.log(headers_obj, 'headers_obj')
    const res = await axios.get(apiUrl + "/getUsers?branch_id=ALL", headers_obj);

    if (res.data) {
      return res.data;
    }
  } catch (error) {
    console.log(error);
    return [];
  }
}

export const uploadProfileImageById = async (user_id, requestData) => {
  try {
    const res = await axios.put(
      `${apiUrl}updateUserProfileImageById/${user_id}`,
      requestData,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Required
          'ZCFKEY': apiKey
        },
        onUploadProgress: progressEvent => {
          const percent = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          )
          console.log(`Upload: ${percent}%`)
        }
      }
    )
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error fetching branch:', error)
    return {}
  }
}

export const updateUserById = async (requestObj, user_id) => {
  try {
    const res = await axios.put(
      `${apiUrl}updateUserById/${user_id}`,
      requestObj,
      {
        headers: {
          'Content-Type': 'application/json',
          'ZCFKEY': apiKey
        }
      }
    )
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error fetching branch:', error)
    return {}
  }
}

export const updateAddonsById = async (requestObj, addon_id) => {
  try {
    console.log(requestObj)
    const res = await axios.put(`${apiUrl}new_addon/${addon_id}`, requestObj, headers_obj)
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error fetching branch:', error)
    return {}
  }
}

export const createAddonApi = async requestObj => {
  try {
    console.log(requestObj)
    const res = await axios.post(`${apiUrl}addons`, requestObj, headers_obj)
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error fetching branch:', error)
    return {}
  }
}

export const createPackageApi = async requestObj => {
  try {
    console.log(requestObj)
    const res = await axios.post(`${apiUrl}createPackage`, requestObj, headers_obj)
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error fetching branch:', error)
    return {}
  }
}

export const updatePackageApi = async (requestObj, package_id) => {
  try {
    console.log(requestObj)
    const res = await axios.put(`${apiUrl}package/${package_id}`, requestObj, headers_obj)
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error fetching branch:', error)
    return {}
  }
}

export const getPackages = async (branch_id = '', is_active = '') => {
  try {
    var url = `${apiUrl}packages`
    console.log(branch_id, 'qweqweqwe')
    if (branch_id) {
      url = `${url}?branch_id=${branch_id}`
    }
    if (is_active) {
      url = `${url}&is_active=${is_active}`
    }
    const res = await axios.get(url, headers_obj)
    if (res.data && res.data.packages) {
      return res.data.packages
    }
    return []
  } catch (error) {
    console.error('Error fetching addons:', error)
    return []
  }
}

export const getHappyHours = async (package_id = '', is_active = '') => {
  try {
    var url = `${apiUrl}happyhours`
    console.log(package_id, 'qweqweqwe')
    if (package_id) {
      url = `${url}?package_id=${package_id}`
    }
    if (is_active) {
      url = `${url}&is_active=${is_active}`
    }
    const res = await axios.get(url, headers_obj)
    if (res.data && res.data.happyHours) {
      return res.data.happyHours
    }
    return []
  } catch (error) {
    console.error('Error fetching addons:', error)
    return []
  }
}

export const getBookings = async (
  booking_id,
  start_date,
  end_date,
  package_id
) => {
  try {
    const res = await axios.get(
      `${apiUrl}slots/new/calendar/${booking_id}?start_date=${start_date}&end_date=${end_date}`,
      headers_obj
    )
    if (res.data && res.data.data) {
      var k = res.data.data.packages.filter(
        pkg => pkg.package_id === package_id
      )
      return k
    } else {
      return []
    }
  } catch (error) {
    console.error('Error fetching addons:', error)
    return []
  }
}

export const getAvailableSlotss = async (
  branch_id = '',
  package_id = '',
  booking_date = ''
) => {
  try {
    var url = `${apiUrl}available-slots`
    console.log(branch_id, 'branch_id')
    console.log(package_id, 'package_id')
    console.log(booking_date, 'booking_date')
    if (branch_id) {
      url = `${url}?branch_id=${branch_id}`
    }
    if (package_id) {
      url = `${url}&package_id=${package_id}`
    }
    if (booking_date) {
      url = `${url}&booking_date=${booking_date}`
    }
    const res = await axios.get(url, headers_obj)
    if (res.data && res.data.success) {
      return res.data
    }
    return []
  } catch (error) {
    console.error('Error fetching addons:', error)
    return []
  }
}

export const createBookingApi = async requestObj => {
  try {
    console.log(requestObj)
    const res = await axios.post(`${apiUrl}booking`, requestObj, {
      headers: {
        Accept: 'application/json',
        'ZCFKEY': apiKey
      }
    })
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error fetching branch:', error)
    return {}
  }
}

export const verifyPaymentApi = async (requestObj) => {
  try {
    console.log(requestObj);
    const res = await axios.post(`${apiUrl}payments/verify`, requestObj, {
      headers: {
        Accept: 'application/json',
        'ZCFKEY': apiKey
      }
    });
    console.log(res, 'gowty')
    return res;
  } catch (error) {
    console.error("Error fetching branch:", error);
    return {};
  }
}


export const sendEmailConfirmation = async (requestObj) => {
  try {
    console.log(requestObj)
    const res = await axios.post(`${apiUrl}bookingConfirmation`, requestObj, {
      headers: {
        Accept: 'application/json',
        'ZCFKEY': apiKey
      }
    })
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error fetching branch:', error)
    return {}
  }
}

export const sendEmailConfirmationForAdmin = async (requestObj) => {
  try {
    console.log(requestObj)
    const res = await axios.post(`${apiUrl}bookingConfirmationForAdmin`, requestObj, {
      headers: {
        Accept: 'application/json',
        'ZCFKEY': apiKey
      }
    })
    console.log(res, ' ')
    return res
  } catch (error) {
    console.error('Error fetching branch:', error)
    return {}
  }
}


export const getBookingsList = async (branch_id = '', status = '', telecaller_id = '', searchtext = '', start_date = '', end_date = '', offset = '') => {
  try {
    // 1. Initialize URL and SearchParams
    const url = new URL(`${apiUrl}bookings`);
    const params = new URLSearchParams();

    // 2. Append parameters only if they have values
    if (branch_id) params.append('branch_id', branch_id);
    if (status) params.append('status', status);
    if (telecaller_id) params.append('telecaller_id', telecaller_id);
    if (searchtext) params.append('searchtext', searchtext);
    if (start_date) params.append('start_date', start_date);
    if (end_date) params.append('end_date', end_date);
    if (!isNaN(offset) && offset >= 0) params.append('offset', offset);

    const finalUrl = `${url.origin}${url.pathname}?${params.toString()}`;

    console.log('Fetching from:', finalUrl);

    const res = await axios.get(finalUrl, headers_obj);

    if (res.data && res.data.bookings) {
      return res.data.bookings;
    }
    return [];
  } catch (error) {
    console.error('Error fetching bookings:', error);
    return [];
  }
};


export const createPaymentLinkApi = async (requestObj) => {
  try {
    console.log(requestObj)
    const res = await axios.post(`${apiUrl}create-payment-link`, requestObj, {
      headers: {
        Accept: 'application/json',
        'ZCFKEY': apiKey
      }
    })
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error creating bookings payment link:', error)
    return {};
  }
}

export const updateBookingStatus = async (requestObj, booking_id) => {
  try {
    console.log(requestObj)
    const res = await axios.put(`${apiUrl}bookings/update-status/${booking_id}`, requestObj, {
      headers: {
        Accept: 'application/json',
        'ZCFKEY': apiKey
      }
    })
    console.log(res, 'gowty');
    return res
  } catch (error) {
    console.error('Error updating bookings records:', error)
    return {};
  }
}

//admin
export const updateBookingById = async (requestObj, booking_id) => {
  try {
    console.log(requestObj)
    const res = await axios.put(`${apiUrl}bookings/update/${booking_id}`, requestObj, {
      headers: {
        Accept: 'application/json',
        'ZCFKEY': apiKey
      }
    })
    console.log(res, 'gowty');
    return res
  } catch (error) {
    console.error('Error updating bookings records:', error)
    return {};
  }
}

export const createPaymentApi = async (requestObj, booking_id) => {
  try {
    console.log(requestObj)
    const res = await axios.post(`${apiUrl}payment/${booking_id}`, requestObj, {
      headers: {
        Accept: 'application/json',
        'ZCFKEY': apiKey
      }
    })
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error creating bookings payment link:', error)
    return {};
  }
}

export const fetchzcql = async (sql) => {
  try {
    const res = await axios.post(`${apiUrl}zcql`, {
      sql: sql
    }, {
      headers: {
        Accept: 'application/json',
        'ZCFKEY': apiKey
      }
    })
    console.log(res, 'gowty')
    return res
  } catch (error) {
    console.error('Error creating zcql:', error)
    return {};
  }
}